
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tippspiele",
      function () {
        return require("private-next-pages/tippspiele/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tippspiele"])
      });
    }
  